import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import { UnsuscribeComponent } from './components/unsuscribe/unsuscribe.component';

@NgModule({
  imports: [RouterModule.forRoot([
    {
      path: 'unsubscribe',
      component: UnsuscribeComponent
    },
    {
      path: 'login',
      component: LoginComponent
    }, {
      path: 'reset-password',
      component: ResetPasswordComponent
    },
    {
      path: '',
      loadChildren: 'app/module-panel/panel.module#PanelModule',
      canLoad: [AuthGuard]
    }
  ])],
  providers: [AuthGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
